.container input[type='checkbox']:focus + div {
  outline: 3px solid -webkit-focus-ring-color;
  outline-offset: 2px;
}

/* hide focus styles for mouse users */
.container input[type='checkbox']:focus:not(:focus-visible) + div {
  outline: none;
}
